import { z } from "zod";
import { LinkItemSchema } from "../LinkItem";
import { ImageMediaSchema } from "../Media";
import { IconTypesSchema } from "../../skins";
export const IconLinkSchema = z.object({
    iconName: IconTypesSchema.optional(),
    link: LinkItemSchema,
    media: ImageMediaSchema.optional(),
});
//# sourceMappingURL=index.js.map